const defaultRequestOptions = {
  providerPriceList: {
    agency_price_list_only: true,
    include_provider_price_list_item_option_values: true,
    include_provider_price_list_item_options: true,
    include_provider_price_list_previous_price_list: true,
    include_provider_price_list_product_items: true,
    include_provider_price_list_products: true,
  },
}

export default defaultRequestOptions
